import { IGeneralContext } from "Interfaces/Providers/General";
import { GeneralContext } from "providers/Shared/GeneralProvider";
import { useContext } from "react";

export default function useGeneral(): IGeneralContext {
  const context = useContext(GeneralContext);

  return context;
}
